/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

export const CONSUMERS_PATH = "/consumers";
export const CONSUMERS_FILTERS_PATH = `${CONSUMERS_PATH}/filters`;
